import { useQuery } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useGetAllUser = (params?: Record<string, any>) => {
    return useQuery({
        queryKey: ["users", params],
        queryFn: () => adminApi.getAllUser(params),
    });
};
